import styled, { css } from "styled-components";

const columnBase = css`
	padding: 16px 8px 12px 8px;
	display: flex;
	align-items: center;
	min-width: 0;
	overflow: hidden;
	box-sizing: border-box;
	min-height: 80px;
	height: 100%;

	& > * {
		width: 100%;
	}
`;

export const ReceivedCol = styled.div`
	${columnBase};
	flex: 1.5;
	max-width: 250px;
	font-weight: 700;
`;

export const SupplierPartCol = styled.div`
	${columnBase};
	flex: 2;
	font-weight: 700;
`;

export const SupplierCol = styled.div`
	${columnBase};
	flex: 1.3;
`;

export const PartTypeCol = styled.div`
	${columnBase};
	flex: 1.4;
	max-width: 170px;
`;

export const DeadlineCol = styled.div`
	${columnBase};
	flex: 1.3;
	min-width: 135px;
	max-width: 135px;
`;

export const PriceCol = styled.div`
	${columnBase};
	flex: 1;
	min-width: 150px;
	max-width: 150px;
`;

export const ReasonCol = styled.div`
	${columnBase};
	flex: 1.5;
	max-width: 200px;
`;

export const ActionsCol = styled.div`
	${columnBase};
	flex-shrink: 0;
	width: 70px;
	max-width: 70px;
	justify-content: flex-end;
	gap: 4px;

	& > * {
		width: auto;
	}
`;

export const RowContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: stretch;
`;
